module.exports = "<navbar (menu)=\"onMenu($event)\" [userName]=\"user?.name\"></navbar>\r\n<app-customer-list *ngIf=\"showCustomers\" (customerSelect)=\"onCustomerSelected($event)\"></app-customer-list>\r\n<app-customer-detail *ngIf=\"showCustomerDetails\" [selectedCustomer]=\"selectedCustomer\" ></app-customer-detail>\r\n<app-system *ngIf=\"showSystem\"></app-system>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Home/home.component.html
// module id = 490
// module chunks = 1